// AI Agent Solutions Data

export const agentsList = [
  {
    id: "consulting-assistant",
    name: "VC4U Consulting Assistant",
    shortName: "Consulting Assistant",
    description: "Get instant answers about our services, expertise, and how we can help your organization. Perfect for learning about VC4U capabilities and starting your consultation journey.",
    icon: "MessageCircle",
    color: "#00FFD1",
    placeholder: "Ask about our services, expertise, or how we can help...",
    examples: [
      "What ASPICE consulting services do you offer?",
      "How can you help with Android Automotive development?",
      "What industries do you serve?",
      "Tell me about your staffing solutions"
    ]
  },
  {
    id: "code-review",
    name: "Code Review Agent",
    shortName: "Code Review",
    description: "Analyze your code for quality, security vulnerabilities, best practices, and optimization opportunities. Supports multiple languages including Python, Java, C++, and JavaScript.",
    icon: "Code",
    color: "#6FD2C0",
    placeholder: "Paste your code here for review...",
    examples: [
      "Review this Python function for best practices",
      "Check this code for security vulnerabilities",
      "Suggest optimizations for this algorithm",
      "Is this code following AUTOSAR standards?"
    ]
  },
  {
    id: "requirements-analyzer",
    name: "Requirements Analyzer",
    shortName: "Requirements Analyzer",
    description: "Analyze software requirements for completeness, clarity, testability, and ASPICE compliance. Identify gaps, ambiguities, and improvement opportunities.",
    icon: "FileSearch",
    color: "#00D4AA",
    placeholder: "Paste your requirements here for analysis...",
    examples: [
      "Check these requirements for ASPICE compliance",
      "Identify ambiguities in this specification",
      "Are these requirements testable?",
      "Suggest improvements for traceability"
    ]
  },
  {
    id: "rfq-assistant",
    name: "RFQ/RFP Assistant",
    shortName: "RFQ Assistant",
    description: "Get help structuring professional RFQ/RFP responses. Generate compliance matrices, risk narratives, and technical response sections aligned with OEM expectations.",
    icon: "FileText",
    color: "#4ECDC4",
    placeholder: "Describe the RFQ requirement or paste the question...",
    examples: [
      "Help me respond to this technical capability question",
      "Draft a risk mitigation section for automotive software",
      "Create a compliance matrix for ASPICE requirements",
      "Structure a delivery model proposal"
    ]
  }
];

export const getAgentById = (id) => agentsList.find(agent => agent.id === id);
